import React, { useContext, useState, useEffect } from "react";
import { AiFillDelete } from "react-icons/ai";
import { LuPanelLeftClose } from "react-icons/lu";
import { ContextApp } from "../utils/Context.jsx";
import { ThemeContext } from "../components/ThemeContext";
import NewChatButton from "./ui/NewChatButton.tsx";

const RightSidebar = () => {
  const {
    resetChat,
    topics = [],
    loadChatHistoryForTopic,
    deleteTopicFromList,
    isGuest,
    setIsChatOpened,
    collections,
    selectedCollection,
    setSelectedCollection,
    loadCollections,
    loadDocumentsForCollection
  } = useContext(ContextApp);

  const { isDarkMode } = useContext(ThemeContext);
  const { setIsSidebarCollapsed } = useContext(ContextApp);

  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    loadCollections();
  }, []);

  const handleCollapse = () => {
    setIsCollapsed(!isCollapsed);
    setIsSidebarCollapsed(!isCollapsed);
  };

  const handleOpenChat = (topicId) => {
    setIsChatOpened(true);
    loadChatHistoryForTopic(topicId);
  };

  const handleDeleteTopic = (e, topicId) => {
    e.stopPropagation();
    deleteTopicFromList(topicId);
  };

  const handleCollectionSelect = async (collection) => {
    setSelectedCollection(collection);
    await loadDocumentsForCollection(collection);
  };

  return (
    <div
      className={`fixed top-0 right-0 h-full border-l z-50 shadow-lg transition-all duration-300 flex flex-col ${
        isCollapsed ? "w-[60px]" : "w-[300px]"
      } ${
        isDarkMode
          ? "bg-neutral-800 text-white border-neutral-700"
          : "bg-gray-200 text-black"
      }`}
    >
      <div className="p-4 mt-5 flex justify-start">
        <button
          className={`${
            isDarkMode
              ? "text-gray-400 hover:text-white"
              : "text-gray-600 hover:text-black"
          }`}
          onClick={handleCollapse}
        >
          <LuPanelLeftClose size={38} />
        </button>
      </div>

      {!isCollapsed && (
        <div className="flex flex-col flex-grow p-4">
          {!isGuest && (
            <>
              <div className="flex flex-col flex-grow-0 mb-4">
                <h2 className="text-xl font-bold text-green-500">Historial</h2>
                <div
                  className="flex flex-col mt-2 space-y-2 overflow-y-auto no-scrollbar"
                  style={{ maxHeight: "400px" }}
                >
                  {topics.length > 0 ? (
                    topics.map((topic) => (
                      <div
                        key={topic.id}
                        className={`flex justify-between items-center p-2 rounded-md cursor-pointer font-medium ${
                          isDarkMode
                            ? "bg-neutral-900 hover:bg-gray-700"
                            : "bg-gray-100 hover:bg-gray-200"
                        }`}
                        onClick={() => handleOpenChat(topic.id)}
                      >
                        <span className="truncate">{topic.name}</span>
                        <AiFillDelete
                          className="text-red-500 hover:text-red-700"
                          onClick={(e) => handleDeleteTopic(e, topic.id)}
                        />
                      </div>
                    ))
                  ) : (
                    <p className="text-gray-500">No hay temas disponibles</p>
                  )}
                </div>
              </div>

              <div className="flex flex-col flex-grow">
                <h2 className="text-lg font-bold mb-2">Colecciones</h2>
                <div
                  className="flex flex-col space-y-2 overflow-y-auto no-scrollbar"
                  style={{ maxHeight: "200px" }}
                >
                  {collections.map((collection) => (
                    <div
                      key={collection}
                      className={`p-2 rounded-md cursor-pointer font-medium ${
                        selectedCollection === collection
                          ? isDarkMode
                            ? "bg-gray-700"
                            : "bg-gray-300"
                          : isDarkMode
                          ? "bg-neutral-900 hover:bg-gray-700"
                          : "bg-gray-100 hover:bg-gray-200"
                      }`}
                      onClick={() => handleCollectionSelect(collection)}
                    >
                      {collection}
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}
        </div>
      )}
      {!isCollapsed && (
        <div className="p-4 mb-4">
          <NewChatButton onClick={resetChat} />
        </div>
      )}
    </div>
  );
};

export default RightSidebar;